var version = {
    "name":      "dativery",
    "buildDateCode": "20260317-163527",
    "buildDate": "Tue Mar 17 2026 16:35:27 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260317-163527",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;